import { createGlobalState } from 'react-hooks-global-state';
import { emptyDatesObject } from '../../../../../availability_calendar/AvailabilityCalendar';

export const initialGlobalState = {
  isOpen: false,
  searchQuery: '',
  dashData: null,
  bookingDates: [{ ...emptyDatesObject }],
  bookingsList: null,
  dayBookingsData: null,
  occupancyData: null,
  lakeInfoList: null,
  kpis: null,
  selectedLake: null,
  selectedLakeType: null,
};

export const { GlobalStateProvider, useGlobalState } =
  createGlobalState(initialGlobalState);
